export default function Waterdrop() {
  return (
    <div
      className="ion-icon-waterdrop"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<path d="M271,38.6c-0.3-0.4-0.7-0.7-0.9-1c0,0-0.1-0.1-0.1-0.1c-3.6-3.4-8.5-5.5-13.9-5.5c-5.5,0-10.4,2.1-13.9,5.5
	c0,0-0.1,0.1-0.1,0.1c-0.3,0.3-0.6,0.6-0.9,1c-6.1,6.3-13.8,14.4-22.4,24.1c-17.4,19.7-38.6,46-58.5,76.8
	c-33.4,51.8-62.9,116.1-64.1,183.1c0,1.3-0.1,2.7-0.1,4c0,19.7,3.9,38.5,10.9,55.8c4.1,10,9.2,19.4,15.2,28.2
	C150.7,452.4,200,480,256,480c88.4,0,160-68.7,160-153.4C416,198.7,310.8,79.2,271,38.6z M256,424c-15.8,0-30.7-3.7-43.9-10.1
	c65.9-14.4,118.4-64.7,135.8-129.5c5.2,12.1,8.2,25.5,8.2,39.6C356,379.2,311.2,424,256,424z"/>
</svg>
`,
      }}
    />
  )
}
